export default "__VITE_ASSET__0c694d33__"